<template>
  <div>
    <center><h6>Total Monthly Expense</h6></center>
    <h5 class="info-text">What is the total amout you spend monthly? This help you to avoid overspending.</h5>
    <div class="row justify-content-center">
      
      <div class="col-12 col-sm-10 mt-3">
        
        <fg-input label="Monthly Expenditure (required)"
          type="number"
          name="income"
          error="Provide the total amount you spend monthly"
          v-validate="modelValidations.income"
          v-model="model.income"
        >
        </fg-input>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    
    data() {
      return {
        model: {
          income: ''
        },
        modelValidations: {
          income: {
            required: true
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model)
          return res
        })
      }
    }
  }
</script>
<style lang="scss">
  .card-wizard .picture-container .picture {
    input[type="file"] {
      display: none;
    }
  }
</style>
